import React from 'react';
import Meta from '../components/Meta';
import { ListGridBanner, ListGridBannerMinor } from '../components/Banners';
import { ListGridItem } from '../components/PageHelpers';
import Cheers2024 from '../images/cheers-abstract.png';
import SecondStreetFestival2024 from '../images/2nd-street-abstract.png';
import RiverRock2024 from '../images/riverrock-2024.jpeg';
import LiveDowntownCover from '../images/vr-live-downtown.jpg';
import WorkDowntownCover from '../images/vr-work-downtown.jpg';


const ListGrid = ({ data }) => {
  const page = data.mortyPage;
  let gridData;

  // Filter out Featured Events page
  let allPages;
  if (data.allMortyPage != null) {
    allPages = data.allMortyPage.edges.filter(p => p.node.title != 'Featured Events');
  }

  // If there are events, add them to the data
  if (data.allMortyEvent != null) {
    gridData = allPages.concat(data.allMortyEvent.edges);
  } else {
    gridData = allPages;
  }
  // Force ordering
  const pageRoutes = [
    '/explore-downtown/riverfront-canal-walk/',
    '/explore-downtown/restaurants/',
    '/explore-downtown/shopping/',
    '/explore-downtown/arts-and-culture/',
    '/explore-downtown/outdoors/',
    '/explore-downtown/attractions/',
    '/explore-downtown/outdoors-attractions/',
    '/explore-downtown/outdoors-attractions/james-river-park-system/',
    '/explore-downtown/parking-and-transportation/',

    '/live-downtown/historic-neighborhoods/',
    '/live-downtown/virtual-tour/',
    '/live-downtown/residential-facts/',
    '/live-downtown/places-to-live/',
    '/live-downtown/living-essentials/',

    '/work-downtown/demographics/',
    '/work-downtown/virtual-tour/',
    '/work-downtown/development/',
    '/work-downtown/relocating/',

    '/our-events/friday-cheers/',
    '/our-events/2nd-street-festival/',
    '/our-events/richmond-folk-festival/',
    '/our-events/camp-kanawha-halloween-cruises/',
    '/our-events/movies-on-browns-island/',

    '/our-services/riverfront-canal-cruises/',
    '/our-services/browns-island-improvement-plan/',
    '/our-services/downtown-marketing/',
    '/our-services/clean-safe-green/',
    '/our-services/browns-island-rentals/',

    '/about-us/our-board/',
    '/about-us/our-staff/',
    '/about-us/our-contributors/',
    '/about-us/donate/',
    '/about-us/faq/',
    '/about-us/reports/',
    '/about-us/about-venture-richmond/',
    '/about-us/contact-us/',

    '/manchester-spotlight/downtown-connections/',
    '/manchester-spotlight/a-taste-of-manchester/',
    '/manchester-spotlight/get-outdoors/',
    '/manchester-spotlight/home-sweet-home/',
    '/manchester-spotlight/local-legends/',
    '/manchester-spotlight/tune-in/',
  ];

  const orderedPages = [];
  if (gridData) {
    // a ListGrid page with no content blows up because gridData is null
    pageRoutes.forEach((route, index) => {
      const page = gridData.find(obj => obj.node.route === route);
      orderedPages.push(page);
    });
  }

  // Filter out undefined values
  const filteredPages = orderedPages.filter(Boolean);

  // Catch for pages that aren't Our Events
  // if (page.title != "Our Events") {
  //   orderedPages = gridData;
  // }

  // Render blocks
  let blocks;
  if (filteredPages) {
    blocks = filteredPages.map(d => <ListGridItem key={d.node.id} page={d.node} />);
  }

  // Render banner
  const Banner = ({ page }) => {
    if (
      page.title != 'Live Downtown' &&
      page.title != 'Explore Downtown' &&
      page.title != 'Work Downtown'
    ) {
      // abstractPhotoForMobile is hacky fix for one specific page while avoiding making database and graphql schema changes
      return <ListGridBannerMinor page={page} abstractPhotoForMobile={page.route === '/manchester-spotlight/'} />;
    }
    return <ListGridBanner page={page} />;
  };

  return (
    <div>
      <Meta page={page} />
      <Banner page={page} />
      <div className="pv3 pv4-m pv5-l flex items-center justify-center">
        <div className="w-100">
          {/* hardcoding the 2022 Friday Cheers + 2ndStreetFestival list items because we're having CMS issues 2/3/22 */}

          {page.slug === 'our-events' ?
            <div className="flex-column">
              <div className="list-grid-item flex mb1 mb0-m mw-1060 center-m relative">
                <a className="list-grid-item__info bg-stone dark relative flex flex-column justify-between" href="/our-events/friday-cheers/">
                  <div>
                    <h2 className="p-averta p-lead-averta--m h-2--l">Friday Cheers</h2>
                    <p className="p--small mt1-l p--m ttu-m h-3--l mbo">Your favorite summer concert series is back to bring you the best music at the best price on Brown's Island every Friday in May &amp; June</p>
                  </div>
                  <div className="flex jusitfy-start items-center">
                    <h6 className="o-40 dark h-6 ttu mb0 tc">Learn More</h6>
                  </div>
                </a>
                <a className="list-grid-item__image bg-blue flex ml0 mt2-m mt3-l" href="/our-events/friday-cheers/">
                  <img alt="Friday Cheers" className="w-100 h-100 image-cover mb0" src={Cheers2024} />
                </a>
              </div>

              <div className="list-grid-item flex mb1 mb0-m mw-1060 center-m relative">
                <a className="list-grid-item__info bg-stone dark relative flex flex-column justify-between" href="/our-events/dominion-energy-riverrock/">
                  <div>
                    <h2 className="p-averta p-lead-averta--m h-2--l">Dominion Energy Riverrock</h2>
                    <p className="p--small mt1-l p--m ttu-m h-3--l mbo">Explore Richmond's great outdoors at the nation's premier sports and action-packed festival on the East Coast.</p>
                  </div>
                  <div className="flex jusitfy-start items-center">
                    <h6 className="o-40 dark h-6 ttu mb0 tc">Learn More</h6>
                  </div>
                </a>
                <a className="list-grid-item__image bg-blue flex ml0 mt2-m mt3-l" href="/our-events/dominion-energy-riverrock/">
                  <img alt="River Rock" className="w-100 h-100 image-cover mb0" src={RiverRock2024} />
                </a>
              </div>


              <div className="list-grid-item flex mb1 mb0-m mw-1060 center-m relative">
                <a className="list-grid-item__info bg-stone dark relative flex flex-column justify-between" href="/our-events/2nd-street-festival/">
                  <div>
                    <h2 className="p-averta p-lead-averta--m h-2--l">2nd Street Festival</h2>
                    <p className="p--small mt1-l p--m ttu-m h-3--l mbo">This community festival is an annual celebration of the Historic Jackson Ward neighborhood in downtown Richmond.</p>
                  </div>
                  <div className="flex jusitfy-start items-center">
                    <h6 className="o-40 dark h-6 ttu mb0 tc">Learn More</h6>
                  </div>
                </a>
                <a className="list-grid-item__image bg-blue flex ml0 mt2-m mt3-l" href="/our-events/2nd-street-festival/">
                  <img alt="Second Street Festival" className="w-100 h-100 image-cover mb0" src={SecondStreetFestival2024} />
                </a>
              </div>
            </div>
            : null
          }

          {page.slug === 'live-downtown' ?
            <div className="flex-column">
              <div className="list-grid-item flex mb1 mb0-m mw-1060 center-m relative">
                <a className="list-grid-item__info bg-stone dark relative flex flex-column justify-between" href="/live-downtown/virtual-tour/">
                  <div>
                    <h2 className="p-averta p-lead-averta--m h-2--l">Virtual Tour</h2>
                    <p className="p--small mt1-l p--m ttu-m h-3--l mbo">A DRONE-BASED MAP THAT ALLOWS YOU TO TOUR DOWNTOWN RICHMOND VIRTUALLY.</p>
                  </div>
                  <div className="flex jusitfy-start items-center">
                    <h6 className="o-40 dark h-6 ttu mb0 tc">Learn More</h6>
                  </div>
                </a>
                <a className="list-grid-item__image bg-blue flex ml0 mt2-m mt3-l" href="/live-downtown/virtual-tour/">
                  <img alt="Virtual tour" className="w-100 h-100 image-cover mb0" src={LiveDowntownCover} />
                </a>
              </div>
            </div>
            : null
          }

          {page.slug === 'work-downtown' ?
            <div className="flex-column">
              <div className="list-grid-item flex mb1 mb0-m mw-1060 center-m relative">
                <a className="list-grid-item__info bg-stone dark relative flex flex-column justify-between" href="/work-downtown/virtual-tour/">
                  <div>
                    <h2 className="p-averta p-lead-averta--m h-2--l">Virtual Tour</h2>
                    <p className="p--small mt1-l p--m ttu-m h-3--l mbo">A DRONE-BASED MAP THAT ALLOWS YOU TO TOUR DOWNTOWN RICHMOND VIRTUALLY.</p>
                  </div>
                  <div className="flex jusitfy-start items-center">
                    <h6 className="o-40 dark h-6 ttu mb0 tc">Learn More</h6>
                  </div>
                </a>
                <a className="list-grid-item__image bg-blue flex ml0 mt2-m mt3-l" href="/work-downtown/virtual-tour/">
                  <img alt="Virtual tour" className="w-100 h-100 image-cover mb0" src={WorkDowntownCover} />
                </a>
              </div>
            </div>
            : null
          }

          {blocks}
          {page.slug === 'our-events' && data.featuredEventsPage && (
            <ListGridItem page={data.featuredEventsPage} full />
          )}
        </div>
      </div>
    </div>
  );
};

export default ListGrid;

export const pageQuery = graphql`
  query ListGrid($id: String!, $section: String) {
    mortyPage(id: { eq: $id }) {
      title
      route
      slug
      subtitle
      bannerImageAltText
      abstractPhotoAltText
      bannerImageFocalPointX
      bannerImageFocalPointY
      bannerImage {
        url
      }
      abstractPhotoFocalPointX
      abstractPhotoFocalPointY
      abstractPhoto {
        url
      }
      metaTitle
      metaDescription
      metaKeywords
    }
    featuredEventsPage: mortyPage(slug: { eq: "featured-events" }) {
      route
      title
      abstract
      abstractPhotoAltText
      abstractPhoto {
        url
      }
      abstractPhotoFocalPointX
      abstractPhotoFocalPointY
    }
    allMortyPage(
      filter: {
        section: { eq: $section }
        title: { ne: "Friday Cheers Lineup" }
      }
    ) {
      edges {
        node {
          id
          title
          section
          abstract
          route
          abstractPhotoAltText
          abstractPhotoFocalPointX
          abstractPhotoFocalPointY
          abstractPhoto {
            url
          }
        }
      }
    }
    allMortyEvent(filter: { section: { eq: $section } }) {
      edges {
        node {
          id
          title
          section
          abstract
          route
          abstractPhotoAltText
          abstractPhotoFocalPointX
          abstractPhotoFocalPointY
          abstractPhoto {
            url
          }
        }
      }
    }
  }
`;

export const previewQuery = `
  query ListGrid($id: String!, $section: String) {
    mortyPage(id: { eq: $id }) {
      title
      route
      slug
      subtitle
      bannerImageAltText
      abstractPhotoAltText
      bannerImageFocalPointX
      bannerImageFocalPointY
      bannerImage {
        url
      }
      abstractPhotoFocalPointX
      abstractPhotoFocalPointY
      abstractPhoto {
        url
      }
      metaTitle
      metaDescription
      metaKeywords
    }
    featuredEventsPage: mortyPage(slug: { eq: "featured-events" }) {
      route
      title
      abstract
      abstractPhotoAltText
      abstractPhoto {
        url
      }
      abstractPhotoFocalPointX
      abstractPhotoFocalPointY
    }
    allMortyPage(
      filter: {
        section: { eq: $section }
        title: { ne: "Friday Cheers Lineup" }
      }
    ) {
      edges {
        node {
          id
          title
          section
          abstract
          route
          abstractPhotoAltText
          abstractPhotoFocalPointX
          abstractPhotoFocalPointY
          abstractPhoto {
            url
          }
        }
      }
    }
    allMortyEvent(filter: { section: { eq: $section } }) {
      edges {
        node {
          id
          title
          section
          abstract
          route
          abstractPhotoAltText
          abstractPhotoFocalPointX
          abstractPhotoFocalPointY
          abstractPhoto {
            url
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/List-Grid.js